// file: client/src/config/shp.config.js
/**
 * PHARMAKON — SHP (Supplément Honoraire Pharmacien) mapping
 *
 * SINGLE SOURCE OF TRUTH (client side) for classification → SHP amount.
 * Mirror of server `src/config/shp.config.js` — keep the two in sync.
 *
 * Authoritative spec (user-confirmed 2026-07-02):
 *   LISTE_I    (Tableau A) → 2.50 DA
 *   LISTE_II   (Tableau C) → 1.50 DA
 *   HORS_LISTE             → 0.00 DA
 *   TABLEAU_B              → 0.00 DA (hospital-only stupéfiants — no officine SHP)
 */

export const SHP_PAR_CLASSIFICATION = Object.freeze({
  LISTE_I: 2.5,
  LISTE_II: 1.5,
  HORS_LISTE: 0,
  TABLEAU_B: 0,
});

/** Resolve the SHP amount for a liste_classification (unknown/null → 0). */
export const shpForClassification = (classification) =>
  SHP_PAR_CLASSIFICATION[classification] ?? 0;

/** Legal whitelist of persistable SHP values (server validators enforce it). */
export const SHP_OPTIONS = [0, 1.5, 2.5];
